import { collection, getDocs, query, where } from "firebase/firestore";
import { useState } from "react";
import { db } from "../../../../firebase";
import AdminButton from "../../../core/admin/adminButton";
import AdminToast from "../../../core/admin/adminToast";
import AdminCard from "../../../core/admin/adminCard";
import AdminTable from "../../../core/admin/adminTable";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { AdminCount } from "../../../core/admin/adminBadge";
import { formatPhoneNumber } from "../../../../utils/functions";

interface IUser {
    id: string;
    name: string;
    phoneNumber: string;
    email: string;
    roles: string[];
}

export default function AdminsList() {
    const [loading, setLoading] = useState(false);
    const [badToast, setBadToast] = useState(false);
    const [admins, setAdmins] = useState<IUser[]>([]);
    const [message, setMessage] = useState("");

    const searchAdmins = async () => {
        try {
            let docs: any[] = []
            setLoading(true);
            const col = collection(db, "users");
            const q = query(col, where("roles", "array-contains", "admin"));
            const documents = await getDocs(q);
            documents.docs.map(doc => docs.push({ id: doc.id, ...doc.data() }));
            setAdmins(docs);
            setMessage("Busca realizada!");
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false);
            setMessage("");
            setBadToast(true);
        }
    }

    return (
        <AdminCard
            title={<>Usuários administradores {message ? <AdminCount count={admins.length} /> : null}</>}
            actions={<AdminButton variant="secondary" loading={loading} onClick={searchAdmins}>{message ? "Atualizar lista" : "Listar"}</AdminButton>}
            bodyClassName="p-3 md:p-4"
        >
            {
                loading ?
                    <AdminLoading />
                    : admins.length ?
                        <AdminTable
                            rows={admins}
                            rowKey={(adm, idx) => adm.id || idx}
                            columns={[
                                { header: "Nome", mobile: "title", render: adm => <span className="font-semibold">{adm.name || "—"}</span> },
                                { header: "E-mail", render: adm => <span className="break-all">{adm.email}</span> },
                                { header: "Telefone", className: "whitespace-nowrap", render: adm => adm.phoneNumber ? formatPhoneNumber(adm.phoneNumber) : "—" },
                                { header: "ID", render: adm => <span className="font-mono text-xs text-gray-500 break-all">{adm.id}</span> },
                            ]}
                        />
                        :
                        <AdminEmptyState title={message ? "Nenhum administrador encontrado" : "Nenhum usuário listado"} description={message ? undefined : "Clique em “Listar” para carregar os administradores."} />
            }
            <AdminToast message="Erro na busca!" toast={badToast} setToast={setBadToast} tone="danger" />
        </AdminCard>
    )
}
